import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal, Switch } from 'antd';
import * as Icon from "react-feather";
import { useDispatch } from 'react-redux';
import appLoaderAction from '../../../redux/action/app-loader-action';
import notifyUtitls from '../../../utils/notify-utils';
import photoGalleryService from '../../../services/photo-gallery-service';
import { fileTYPE_IMG, galleryType } from '../../../constants/app-constants';
import fileUtils from "../../../utils/file-utils";
import UploadImage from '../../../components/upload/image';

const AddEditImageDialog = ({ isShow, onCancel, onSaveComplete, editData, currentParent, currentFolder, currentPath }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [imageShow, setImageShow] = useState(null);
    const [imageList, setImageList] = useState([]);

    useEffect(() => {
        if (!isShow) {
            setImageList([]);
            setImageShow(null);
        }
    }, [isShow]);

    useEffect(() => {
        if (isShow && editData) {
            form.setFieldsValue({
                shortDescription: editData.shortDescription,
                enable: editData.enable
            });
            setImageShow(editData);
        } else {
            form.setFieldsValue({
                shortDescription: null,
                enable: true
            });
        }
    }, [isShow, editData]);

    const onSave = async () => {
        try {
            let path = "/"
            const values = await form.validateFields();
            const formData = new FormData();
            if (currentParent === "root") {
                formData.append("parent", currentParent);
                formData.append("path", "");
            } else {
                formData.append("parent", currentParent);
                currentPath.forEach((res) => {
                    path = path + res + "/";
                });

                formData.append("path", path);
            }

            try {
                dispatch(appLoaderAction.enable());
                if(!editData){
                    let itemsProcessed = 0;
                    formData.append("enable", values.enable);
                    formData.append("shortDescription", values.shortDescription);
                    for (const image of imageList) {
                        formData.append("file", image.originFileObj);
                        await photoGalleryService.add(formData);
                        itemsProcessed++;
                        if(itemsProcessed === imageList.length) {
                            callbackResult();
                        }
                    }
                } else {
                    let bean = JSON.parse(JSON.stringify(editData));
                    formData.append("id", bean.id);
                    formData.append("shortDescription", values.shortDescription);
                    formData.append("enable", values.enable);
                    formData.append("file", imageList.originFileObj);
                    await photoGalleryService.edit(formData);
                    callbackResult();
                }
            } catch (err) {
                notifyUtitls.error(err);
			} finally {
                dispatch(appLoaderAction.disale());
            }
        } catch (errorInfo) {
            notifyUtitls.warning('แจ้งเตือน', 'โปรดระบุข้อมูลให้ครบถ้วน');
        }
    }

    const callbackResult = () => {
            onSaveComplete();
            notifyUtitls.success('สำเร็จ', 'บันทึกสำเร็จ')
            dispatch(appLoaderAction.disale());
    }

    const onChangeUploadImage = ({ fileList }) => {
        setImageList(fileUtils.composeUrlInFileList(fileList));
    };

    const onChangeEditUploadTemp = ({ file, fileList }) => {
        if (file.status === 'done') {
            const { bean } = file.response;
            setImageShow(bean);
        }
        setImageList(file);
    };

    const uploadButton = (
        <div>
          <div style={{ marginTop: 8 }}>อัปโหลดไฟล์</div>
        </div>
      );

    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    }

    return (
        <div className="container h-100">
            <div className="title-page">
                <Modal
                    title={
                        editData ? 'แก้ไขรูปภาพ' : 'เพิ่มรูปภาพ (ไม่เกิน 10 รูป)'
                    }
                    centered
                    width={400}
                    visible={isShow}
                    onCancel={onCancel}
                    destroyOnClose
                    footer={[
                        <Button key="submit" type="primary" onClick={onSave}>
                            <Icon.Save className="me-2" size={17} />{editData ? 'บันทึก' : 'เพิ่มรูปภาพ'}
                        </Button>,
                        <Button key="back" className="btn-gray" onClick={onCancel}>
                            <Icon.X className="me-2" size={17} />ยกเลิก
                        </Button>,
                    ]}>
                    <Form
                        layout="vertical"
                        name="add_edit_banner"
                        preserve={false}
                        form={form}
                        initialValues={{status: true, enableNewTab: true}}
                        validateMessages={{
                            required: 'โปรดระบุ',
                        }}>
                        <Form.Item
                            label="รูปภาพ"
                            valuePropName="fileList"
                            getValueFromEvent={normFile}
                            name="fileList">
                            {editData ? (
                                <UploadImage
                                    listType="picture-card"
                                    accept={fileTYPE_IMG}
                                    showUploadList={false}
                                    onChange={onChangeEditUploadTemp}
                                    className={imageShow ? 'view-upload' : null}>
                                    {imageShow ? (
                                        <img
                                            src={
                                                imageShow.tempFilename
                                                    ? fileUtils.getTempFileRenderUrl(
                                                        imageShow.tempFilename,
                                                        imageShow.type
                                                    )
                                                    : fileUtils.getGalleryRenderUrl(
                                                        galleryType.PHOTO, 
                                                        imageShow.path, 
                                                        imageShow.fileName
                                                    )
                                            }
                                            alt="avatar"
                                            style={{ width: '100%' }}
                                        />
                                    ) : 'อัปโหลดไฟล์'}
                                </UploadImage>
                            ) : (
                                <UploadImage
                                    listType="picture-card"
                                    accept={fileTYPE_IMG}
                                    onChange={onChangeUploadImage}
                                    fileList={imageList}
                                >
                                    {imageList.length >= 10 ? null : (uploadButton)}
                                    {/* {uploadButton} */}
                                </UploadImage>
                            )}
                        </Form.Item>

                        <Form.Item
                            key="shortDescription"
                            label="คำอธิบาย"
                            name="shortDescription"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}>
                            <Input />
                        </Form.Item>

                        <Form.Item label="การแสดง" name="enable" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        </div>
    )
}

export default AddEditImageDialog;
